import ScoreRing from './ScoreRing';
import { keyFactors } from '../../utils/readinessAssessment';

/**
 * Desktop score rail (≥1024px): animated ring + label, six segmented
 * category bars (Provided / Proof uploaded / Verified tiers), legend,
 * and key eligibility/pricing factors as they're collected. Per-question
 * education lives on the glowing Owen avatars in the chat, not here.
 */
export default function ScoreRail({ score, scoreColor, scoreLabel, cats, answers = {} }) {
  const factors = keyFactors(answers);
  return (
    <aside className="rdz-rail">
      <div>
        <div className="rdz-rail__overline">Readiness Score</div>
        <div className="rdz-rail__score-row">
          <ScoreRing score={score} color={scoreColor} size="small">
            <div className="rdz-ring__num">{score}</div>
          </ScoreRing>
          <div>
            <div className="rdz-rail__score-label" style={{ color: scoreColor }}>{scoreLabel}</div>
            <div className="rdz-rail__score-caption">
              Builds as you answer. Proof &amp; verification unlock full value later.
            </div>
          </div>
        </div>
      </div>
      <div className="rdz-divider" />
      <div className="rdz-rail__cats">
        {cats.map((c) => (
          <div key={c.id}>
            <div className="rdz-cat__head">
              <span className="rdz-cat__label">{c.label}</span>
              <span className="rdz-cat__pts">{c.ptsLabel}</span>
            </div>
            <div className="rdz-cat__track">
              <div className="rdz-cat__seg" style={{ background: c.color, width: c.pct }} />
              <div className="rdz-cat__seg" style={{ background: c.colorProof, width: c.pctProof }} />
              <div className="rdz-cat__seg" style={{ background: c.colorVerif, width: c.pctVerif }} />
            </div>
          </div>
        ))}
        <div className="rdz-legend">
          <span className="rdz-legend__item"><span className="rdz-legend__swatch" style={{ background: '#4f46e5' }} />Provided</span>
          <span className="rdz-legend__item"><span className="rdz-legend__swatch" style={{ background: '#4f46e559' }} />Proof uploaded</span>
          <span className="rdz-legend__item"><span className="rdz-legend__swatch" style={{ background: '#4f46e526' }} />Verified</span>
        </div>
        <div className="rdz-rail__tiers-caption">
          What you share earns 60% of each category. Uploading proof, then our verification that it
          matches, unlocks the rest.
        </div>
      </div>
      {factors.length > 0 && (
        <>
          <div className="rdz-divider" />
          <div className="rdz-factors">
            <div className="rdz-rail__overline">Your key numbers</div>
            <div className="rdz-factors__caption">What lenders price and qualify from.</div>
            {factors.map((f) => (
              <div className="rdz-factor" key={f.label}>
                <div className="rdz-factor__row">
                  <span className="rdz-factor__label">{f.label}</span>
                  <span className="rdz-factor__value">{f.value}</span>
                </div>
                <div className="rdz-factor__hint">{f.hint}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </aside>
  );
}
